import { InjectionToken } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export const STATE_PROVIDER = new InjectionToken<StateProvider<any>>('STATE_PROVIDER');

export interface StateProvider<T> {
  stateChanges$: Observable<T>;
  patchState?(patch: Partial<T>): void;
  reset?(): void;
  snapshot?(): T;
}

/**
 * Default implementation of the PropertySetsDialogActionsStateProvider.
 */
export class DefaultStateProvider implements StateProvider<unknown> {
  private state = new BehaviorSubject<unknown>({ title: 'No state provided' });
  stateChanges$: Observable<unknown> = this.state.asObservable();

  snapshot(): unknown {
    return this.state.value;
  }
}
